import { IProduit } from "./Produit.model";

export interface IStock {
  id?: number;
  etat?: any;
  qteStock?: any;
  qteSeuil?: any;
  prixUnitaire?: any;
  produit?: IProduit;
}
export class Stock implements IStock {
  constructor(
    public id?: number,
    public etat?: any,
    public qteStock?: any,
    public qteSeuil?: any,
    public prixUnitaire?: any,
    public produit?: IProduit
  ) {}
}
